
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4284_8702)"}},[_c('path',{attrs:{"d":"M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M29.318 18.457c1.543.894 1.543 3.124 0 4.014l-5.837 3.37-5.836 3.37c-1.544.893-3.477-.224-3.477-2.007V13.727c0-1.783 1.93-2.9 3.477-2.006l5.836 3.37 5.837 3.37v-.004z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4284_8702"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})])])])
          )
        }
      }
    